module.exports = __webpack_public_path__ + "img/icons_15.8f4dc84a.png";